console.log('Vite ⚡️ Rails');

import '@hotwired/turbo-rails';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap';
import '@fortawesome/fontawesome-free/js/solid';
import '@fortawesome/fontawesome-free/js/fontawesome';
import '../styles/timeline.css';
